import {DEFAULT_GLA_ID} from "../../../../hooks/useGLAccounts.ts";

export const ACCOUNTS_PAYABLE_GLA_CODE = "BSchCre";
export const ACCOUNTS_RECEIVABLE_GLA_CODE = "BVorDeb";

export function isOpenItemsAccount(accountCode: string): boolean {
    return (
        accountCode === ACCOUNTS_PAYABLE_GLA_CODE ||
        accountCode === ACCOUNTS_RECEIVABLE_GLA_CODE
    );
}

export function showsPaymentStatus(accountCode: string): boolean {
    return isOpenItemsAccount(accountCode) || accountCode === DEFAULT_GLA_ID;
}
